import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Node3D } from '../../../base/node3d/Component';
import { PluginGizmo } from '../../../../r3f/gizmo/PluginGizmo';
import { JointGizmoLines } from '../joint3d/JointGizmoLines';
import { pinJointSegments } from '../joint3d/jointGizmoDrawer';
import { useJointBodies } from '../joint3d/useJointBodies';
const PIN_SEGMENTS = pinJointSegments();
function PinGizmo({ properties }) {
    if (useJointBodies(properties) === null)
        return null;
    return _jsx(JointGizmoLines, { part: "joint", positions: PIN_SEGMENTS });
}
export function PinJoint3D({ node, children }) {
    return (_jsxs(Node3D, { node: node, children: [_jsx(PluginGizmo, { drawnFor: "every-node", children: _jsx(PinGizmo, { properties: node.properties }) }), children] }));
}
//# sourceMappingURL=Component.js.map